<template>
  <div class="main"></div>
</template>

<script>
export default {
  mounted () {
    this.loadReutersScript()
  },
  methods: {
    loadReutersScript () {
      // load special script for reuters app-reuters.js only when class="main" DOM is loaded
      var script = document.createElement('script')
      script.type = 'text/javascript'

      if (script.readyState) { // IE
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null
            console.log('Reuters script loaded...')
          }
        }
      } else { // Others
        script.onload = function () {
          console.log('Reuters script loaded...')
        }
      }

      script.src = 'reuters/scripts/app-reuters.js'
      document.getElementsByTagName('body')[0].appendChild(script)
    }
  }
}
</script>
